export default __webpack_public_path__ + "images/uploadIcon-1.svg";